const BANNED_WORDS = [
  // Strong profanity
  'fuck', 'fucking', 'fucker', 'fucked', 'fucks', 'fuckhead', 'fuckwit', 'fuckface', 'clusterfuck', 'motherfuck', 'motherfucker', 'motherfucking',
  'shit', 'shitting', 'shitty', 'shithead', 'dipshit', 'bullshit', 'shitstorm', 'shithole', 'shitshow',
  'bitch', 'bitching', 'bitchy', 'bitchass',
  'bastard',
  'cunt', 'cunting',
  'dick', 'dickhead', 'dickface',
  'cock', 'cockhead', 'cocksucker',
  'prick',
  'piss', 'pissed', 'pisser',
  'twat',
  'whore', 'whorish',
  'slut', 'slutty',
  'arse', 'arsehole',
  'asshole', 'asshat', 'asswipe', 'assfuck', 'jackass', 'dumbass', 'smartass', 'fatass', 'numbnuts',
  'douchebag', 'douche',
  'wanker', 'wanking', 'wank',
  'tosser',
  'bellend',
  'knob', 'knobhead',
  'jackoff', 'jerkoff',
  'scumbag', 'scumball',
  'skank', 'skanky',
  'tramp',
  'turd', 'turdface',
  'prat', 'twit', 'git', 'pillock', 'muppet',
  // Mild profanity
  'damn', 'hell', 'crap', 'ass', 'wtf', 'stfu', 'ffs', 'omfg', 'lmfao',
  // Insults
  'stupid', 'idiot', 'dumb', 'moron', 'loser', 'dummy', 'jerk', 'fool', 'dork', 'freak', 'weirdo', 'creep',
  'bimbo', 'airhead', 'ditz',
  'pervert', 'perv',
  'sicko',
  'degenerate',
  'lowlife',
  'psycho',
  'maniac',
  'scumbag',
  'filth', 'filthy',
  // Ableist slurs
  'retard', 'retarded',
  'spaz', 'spastic',
  'mong',
  // Racial / ethnic slurs
  'nigger', 'nigga', 'niggah',
  'chink',
  'spic', 'spick',
  'wetback',
  'kike',
  'gook',
  'towelhead', 'raghead',
  'coon',
  'paki',
  'beaner',
  'cracker',
  'peckerwood',
  'greaseball',
  'wop',
  'dago',
  'polack',
  'kraut',
  'hymie',
  'heeb',
  'injun',
  'redskin',
  'zipperhead',
  'slant',
  // Homophobic / transphobic slurs
  'faggot', 'fag', 'fagg',
  'dyke',
  'tranny',
  'queer',
  // Violence
  'murder', 'murderer',
  'suicide',
  'shoot', 'shooter', 'shooting',
  'gun', 'gunshot',
  'knife', 'knifed',
  'weapon', 'weapons',
  'explosive', 'bomb', 'bombing',
  'grenade',
  'kill', 'killer', 'killing',
  'die', 'dying',
  'death', 'dead',
  'hurt', 'hurting',
  'pain',
  'suffer', 'suffering',
  'injury', 'injured',
  'wounded',
  'attack', 'attacker',
  'assault',
  'fight', 'fighting',
  'punch', 'punching',
  'kick', 'kicking',
  'hit', 'hitting',
  'stab', 'stabbing',
  'cut', 'cutting',
  'burn', 'burning',
  'poison', 'poisoning',
  'destroy', 'destruction',
  'crush',
  'break', 'smash',
  'slaughter', 'massacre',
  'genocide',
  'behead', 'beheading',
  'torture', 'torturing',
  'mutilate', 'mutilation',
  'strangle', 'strangling',
  'choke', 'choking',
  'suffocate',
  // Drugs and alcohol
  'drug', 'drugs',
  'weed', 'pot', 'cannabis', 'marijuana',
  'cocaine', 'crack',
  'heroin',
  'meth', 'methamphetamine',
  'mdma', 'ecstasy',
  'lsd', 'acid',
  'fentanyl',
  'ketamine',
  'xanax',
  'adderall',
  'opioid',
  'alcohol', 'beer', 'vodka', 'whiskey', 'whisky', 'tequila', 'bourbon', 'rum', 'gin', 'wine',
  'drunk', 'drunkard',
  'high', 'stoned', 'blazed', 'wasted', 'hammered', 'smashed', 'trashed',
  'smoke', 'smoking', 'cigarette', 'vape', 'vaping',
  'joint', 'blunt', 'bong',
  'pill', 'pills',
  'overdose',
  'dealer', 'dealing',
  'junkie',
  // Threats and extremism
  'violent', 'violence',
  'threat', 'threaten', 'threatening',
  'terror', 'terrorist', 'terrorize',
  'kidnap', 'kidnapping',
  'ransom',
  'hostage',
  'jihad',
  'kkk',
  'nazi', 'nazism',
  'neonazi',
  'white power', 'white supremacy',
  'extremist', 'extremism',
  'incel',
  // Sexual
  'sex', 'sexy', 'sexual',
  'porn', 'porno', 'pornography',
  'nude', 'nudes', 'naked',
  'breast', 'boob', 'boobs', 'tit', 'tits', 'titty', 'titties',
  'penis', 'vagina', 'vulva',
  'balls', 'ballsack', 'nutsack', 'testicle',
  'butthole', 'anus',
  'boner', 'erection',
  'orgasm', 'climax',
  'masturbate', 'masturbation', 'masturbating',
  'horny',
  'blowjob', 'handjob', 'rimjob',
  'cum', 'cumming', 'cumshot',
  'jizz', 'spunk',
  'dildo', 'vibrator',
  'anal',
  'bondage',
  'fetish',
  'orgy', 'gangbang', 'threesome',
  'prostitute', 'prostitution',
  'pimp',
  'hooker', 'escort',
  'stripper', 'lapdance',
  'rape', 'rapist', 'raping',
  'molest', 'molestation', 'molester',
  // Child safety
  'pedophile', 'paedophile', 'pedophilia', 'paedophilia',
  'nonce',
  'grooming',
  'predator',
  // Hate speech
  'racist', 'racism',
  'antisemit', 'antisemitic', 'antisemitism',
  'islamophob', 'islamophobia',
  'homophob', 'homophobia', 'homophobic',
  'transphob', 'transphobia', 'transphobic',
  'bigot', 'bigotry',
  'misogyn', 'misogyny', 'misogynist',
  'misandry',
  // Self-harm
  'suicidal', 'selfharm', 'self-harm',
  'anorexia', 'anorexic',
  'bulimia', 'bulimic',
  'slit', 'slitting',
  'overdose',
  // Bullying
  'bully', 'bullying',
  'harass', 'harassment',
  'stalk', 'stalking',
  'abuse', 'abusive', 'abuser',
  'ugly', 'fat', 'fatso', 'fatty', 'lard',
  'loser', 'pathetic',
  // Crime
  'scam', 'scammer',
  'fraud', 'fraudster',
  'theft', 'thief',
  'rob', 'robbery', 'robber',
  'fake', 'phony', 'counterfeit',
  'blackmail', 'extortion',
  'bribe', 'bribery',
];

const BANNED_PHRASES = [
  'nobody likes', 'everyone hates', 'no one wants',
  'hope you die', 'hope you fail',
  'wish you were dead', 'want you to die', 'want you to suffer',
  'kill yourself', 'kys',
  'go die',
  'suck my',
  'eat shit',
  'fuck you',
  'fuck off',
  'screw you',
  'bite me',
  'white power',
  'white supremacy',
  'neo nazi',
];

const RESERVED_NAME_WORDS = ['test', 'admin', 'kokoverse', 'omore', 'moderator', 'support'];

function normalize(text: string): string {
  return text
    .toLowerCase()
    .replace(/@/g, 'a')
    .replace(/3/g, 'e')
    .replace(/1/g, 'i')
    .replace(/0/g, 'o')
    .replace(/\$/g, 's')
    .replace(/!/g, 'i')
    .replace(/4/g, 'a')
    .replace(/\*/g, '')
    .replace(/\./g, '');
}

function hasBannedWord(text: string): boolean {
  const n = normalize(text);
  for (const word of BANNED_WORDS) {
    if (new RegExp(`\\b${word}\\b`, 'i').test(n)) return true;
  }
  for (const phrase of BANNED_PHRASES) {
    if (n.includes(phrase)) return true;
  }
  return false;
}

function hasPersonalInfo(text: string): boolean {
  // Phone numbers
  if (/(\+?1[-.\s]?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}/.test(text)) return true;
  // Email or obfuscated (x at y dot z)
  if (/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/.test(text)) return true;
  if (/\b\w+\s+at\s+\w+\s+dot\s+\w+\b/i.test(text)) return true;
  // URLs
  if (/https?:\/\/|www\.|[\w-]+\.(com|net|org|io|co|app|me|info|biz|edu)\b/i.test(text)) return true;
  // Physical addresses
  if (/\b\d+\s+\w+\s+(street|st|avenue|ave|road|rd|drive|dr|lane|ln|blvd|boulevard|way|court|ct)\b/i.test(text)) return true;
  if (/\bpo\s+box\b/i.test(text)) return true;
  if (/\b\d{5}(-\d{4})?\b/.test(text)) return true;
  return false;
}

function hasReservedWord(text: string): boolean {
  const n = normalize(text);
  for (const word of RESERVED_NAME_WORDS) {
    if (new RegExp(`\\b${word}\\b`, 'i').test(n)) return true;
  }
  return false;
}

export interface ModerationResult {
  passed: boolean;
  reason?: 'profanity' | 'personalInfo' | 'reservedWord';
  message?: string;
}

/**
 * Run the full client-side word filter on a piece of text.
 * @param isNameField Set true for display names / usernames to also check reserved words.
 */
export function moderateText(text: string, isNameField = false): ModerationResult {
  if (!text?.trim()) return { passed: true };

  if (hasBannedWord(text)) {
    return { passed: false, reason: 'profanity', message: 'Please use kind and appropriate language.' };
  }
  if (hasPersonalInfo(text)) {
    return { passed: false, reason: 'personalInfo', message: "Please don't share personal information." };
  }
  if (isNameField && hasReservedWord(text)) {
    return { passed: false, reason: 'reservedWord', message: 'That name is not available.' };
  }
  return { passed: true };
}
